export function getEntitiesWithInvalidLineTypes(viewer, currentDataSource) {
  if (!currentDataSource || !currentDataSource.entities) return [];

  function normalizeForCompare(str) {
    if (str === null || str === undefined) return "";
    return String(str).toLowerCase().replace(/\s+/g, "").replace(/[-_]+/g, "");
  }

  function getPropertyValueFromProps(props, key) {
    if (!props) return undefined;

    if (typeof props.get === "function") {
      const property = props.get(key);
      if (!property) return undefined;
      return typeof property.getValue === "function" ? property.getValue() : property;
    }

    if (props._properties && typeof props._properties === "object") {
      const property = props._properties[key];
      if (!property) return undefined;
      return typeof property.getValue === "function" ? property.getValue() : property;
    }

    if (typeof props.getValue === "function") {
      const obj = props.getValue();
      if (obj && typeof obj === "object") return obj[key];
    }

    if (Object.prototype.hasOwnProperty.call(props, key)) return props[key];

    return undefined;
  }

  function getEntityId(entity) {
    if (!entity) return undefined;
    const props = entity.properties;
    let idFromProps;

    if (props) {
      if (typeof props.get === "function") {
        const property = props.get("id");
        if (property) idFromProps = typeof property.getValue === "function" ? property.getValue() : property;
      }

      if (idFromProps === undefined && props._properties && typeof props._properties === "object") {
        const property = props._properties.id;
        if (property) idFromProps = typeof property.getValue === "function" ? property.getValue() : property;
      }

      if (idFromProps === undefined && typeof props.getValue === "function") {
        const obj = props.getValue();
        if (obj && typeof obj === "object" && Object.prototype.hasOwnProperty.call(obj, "id")) {
          idFromProps = obj.id;
        }
      }

      if (idFromProps === undefined && Object.prototype.hasOwnProperty.call(props, "id")) {
        idFromProps = props.id;
      }
    }

    if (idFromProps !== undefined && idFromProps !== null) return idFromProps;
    return entity.id;
  }

  function buildIdToLayerMap(viewer, currentDataSource) {
    const map = new Map();
    if (!viewer || !viewer.dataSources) return map;

    const collection = viewer.dataSources;

    for (let i = 0; i < collection.length; i++) {
      const ds = collection.get(i);
      if (!ds || ds === currentDataSource || !ds.entities) continue;

      const layerName = ds.layerName;
      if (!layerName) continue;

      const normLayer = normalizeForCompare(layerName);
      const entities = ds.entities.values || ds.entities;
      if (!Array.isArray(entities)) continue;

      for (let j = 0; j < entities.length; j++) {
        const entity = entities[j];
        if (!entity || !entity.properties) continue;

        const idValue = getPropertyValueFromProps(entity.properties, "id");
        if (idValue === null || idValue === undefined) continue;

        const key = String(idValue);
        if (!map.has(key)) {
          map.set(key, { normLayer, layerName });
        }
      }
    }

    return map;
  }

  const entities = currentDataSource.entities.values || currentDataSource.entities;
  if (!Array.isArray(entities) || entities.length === 0) return [];

  const idToLayerMap = buildIdToLayerMap(viewer, currentDataSource);

  const result = [];
  const seenIds = new Set();

  function checkSide(sideLabel, sideType, sideId) {
    if (!sideType || !sideId) return { checked: false, valid: true, reason: null };

    const info = idToLayerMap.get(String(sideId));
    if (!info) {
      return { checked: false, valid: true, reason: null };
    }

    const normType = normalizeForCompare(sideType);
    const isValid = info.normLayer.includes(normType);

    if (isValid) return { checked: true, valid: true, reason: null };

    const reason = sideLabel === "left" ? "Left line type is invalid" : "Right line type is invalid";

    return { checked: true, valid: false, reason };
  }

  for (let i = 0; i < entities.length; i++) {
    const entity = entities[i];
    if (!entity || !entity.properties) continue;

    const props = entity.properties;

    const leftType = getPropertyValueFromProps(props, "left_line_type");
    const rightType = getPropertyValueFromProps(props, "right_line_type");
    const leftId = getPropertyValueFromProps(props, "left_line_id");
    const rightId = getPropertyValueFromProps(props, "right_line_id");

    const leftCheck = checkSide("left", leftType, leftId);
    const rightCheck = checkSide("right", rightType, rightId);

    const reasons = [];
    if (leftCheck.checked && !leftCheck.valid && leftCheck.reason) reasons.push(leftCheck.reason);
    if (rightCheck.checked && !rightCheck.valid && rightCheck.reason) reasons.push(rightCheck.reason);

    if (reasons.length > 0) {
      const id = getEntityId(entity);
      const dedupeKey = id ?? entity;

      const type = "lanelet_type";

      if (!seenIds.has(dedupeKey)) {
        seenIds.add(dedupeKey);
        result.push({ entity, id, type, reasons });
      }
    }
  }

  return result;
}
